import { inject, Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpParams } from '@angular/common/http';
import { GET_VTN_CHART_ENDPOINT, GET_VTN_LAST_SNAPSHOT_ENDPOINT, } from '../constants/endpoints.constants';
import {
  GetVtnChartParams,
  GetVtnChartResponse,
  GetVtnLastSnapshotParams,
  GetVtnLastSnapshotResponse,
} from '../models/vtns.models';
import { withSpinner } from '../../app/core/services/spinner.controller';

/**
 * Service to interact with VTN data endpoints, including fetching snapshots and chart data.
 */
@Injectable({ providedIn: 'root' })
export class DataVtnsService {
  protected readonly apiService = inject(ApiService);

  /**
   * Retrieves the latest VTN snapshot based on the provided parameters.
   *
   * @param params - Parameters required to query the VTN snapshot.
   * @returns An observable containing the latest VTN snapshot data.
   */
  getVtnLastSnapshot(params: GetVtnLastSnapshotParams) {
    const queryParams = new HttpParams().appendAll({ ...params });
    return this.apiService
      .get<GetVtnLastSnapshotResponse>(
        GET_VTN_LAST_SNAPSHOT_ENDPOINT,
        queryParams,
      )
      .pipe(withSpinner());
  }

  /**
   * Retrieves VTN chart data based on the provided parameters.
   *
   * @param params - Parameters required to query the VTN chart data.
   * @returns An observable containing the VTN chart data.
   */
  getVtnChart(params: GetVtnChartParams) {
    const queryParams = new HttpParams().appendAll({ ...params });
    return this.apiService
      .get<GetVtnChartResponse>(GET_VTN_CHART_ENDPOINT, queryParams)
      .pipe(withSpinner());
  }
}
